var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPaymentWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96675 2.64997C8.96675 2.29098 8.67573 1.99997 8.31675 1.99997C7.95776 1.99997 7.66675 2.29098 7.66675 2.64997V11.346L5.10962 8.78886C4.85578 8.53502 4.44422 8.53502 4.19038 8.78886C3.93654 9.0427 3.93654 9.45426 4.19038 9.7081L7.84614 13.3639C7.96453 13.4881 8.1316 13.5655 8.31675 13.5655C8.37845 13.5655 8.43814 13.5569 8.49469 13.5408C8.49933 13.5395 8.50394 13.5382 8.50852 13.5367C8.60662 13.5066 8.69899 13.4527 8.77661 13.3751L12.4436 9.7081C12.6974 9.45426 12.6974 9.0427 12.4436 8.78886C12.1898 8.53502 11.7782 8.53502 11.5244 8.78886L8.96675 11.3465V2.64997Z",
    fill: "url(#paint0_linear_7628_12774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7628_12774",
    x1: 8.31556,
    y1: 0.354942,
    x2: 8.31556,
    y2: 13.5655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86807"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPaymentWarning);
export default __webpack_public_path__ + "static/media/ArrowPaymentWarning.660a3595f4cc9de28474bf9f7a12f7b3.svg";
export { ForwardRef as ReactComponent };